import React from "react";
import styles from "./index.module.css";
import Image from "../../assets/guru-guides-hero.png";
import { useLanguage } from "../../context/LanguageContext";

interface IntroductionProps {
  title?: string;
  description?: string;
}

const Links = () => {
  const { t } = useLanguage();
  return (
    <mui-link
      href="https://www.figma.com/community/plugin/1471341082690554711/guru-guides"
      target="_blank"
      variant="secondary"
      style={{
        "--action-primary-background": "var(--theme-selected)",
        "--action-primary-background-hover": "var(--theme-selected)",
        "--action-primary-background-focus": "var(--theme-selected)",
      }}
    >
      {t("guides.install")}
    </mui-link>
  );
};

const Advert: React.FC<IntroductionProps> = ({ title, description }) => (
  <mui-v-stack space="var(--space-100)" style={{ borderBottom: "var(--border-thin)" }}>
    <mui-v-stack space="var(--space-400)" style={{ padding: "var(--space-500)" }}>
      <mui-v-stack space="var(--space-200)">
        <mui-heading level="4" size="5">
          {title}
        </mui-heading>
        <mui-body size="small">{description}</mui-body>
      </mui-v-stack>
      <mui-v-stack space="var(--space-200)">
        <Links />
      </mui-v-stack>
    </mui-v-stack>
    <mui-v-stack space="var(--space-000)" class={styles.imageOuter}>
      <img src={Image} alt="figma-plugin" className={styles.image} />
    </mui-v-stack>
  </mui-v-stack>
);

export default Advert;
